import invariant from 'react-utils/invariant';
import PropertyChangedNameAndValueField from '../converters/objectSeg/fieldDefinitions/PropertyChangedNameAndValueField';
import { isOperator } from '../filterQueryFormat/operator/Operator';
import PropertyNameAndValue from '../filterQueryFormat/operator/PropertyNameAndValue';
import { PROPERTY_CHANGED_NAME_AND_VALUE } from '../filterQueryFormat/UnifiedEventPropertyTypes';
export const PROPERTY_CHANGED_EVENT_TYPE_ID_QA = '4-67284';
export const PROPERTY_CHANGED_EVENT_TYPE_ID_PROD = '4-655002';
export const isPropertyNameAndValueCondition = condition => {
  return isOperator(condition) && condition instanceof PropertyNameAndValue;
};
export const isPropertyChangedNameAndValueField = fieldName => {
  return fieldName === PropertyChangedNameAndValueField().name;
};
export const isPropertyChangedEventTypeId = eventTypeId => {
  return eventTypeId === PROPERTY_CHANGED_EVENT_TYPE_ID_PROD || eventTypeId === PROPERTY_CHANGED_EVENT_TYPE_ID_QA;
};
export const isPropertyNameProperty = propertyName => {
  return propertyName === 'hs_name';
};
export const isPropertyValueProperty = propertyName => {
  return propertyName === 'hs_value';
};
export const isPropertyPreviousValueProperty = propertyName => {
  return propertyName === 'hs_previous_value';
};
export const isPropertyChangedNameAndValueFilter = filter => {
  return filter.filterType === PROPERTY_CHANGED_NAME_AND_VALUE;
};
export const convertPropertyNameAndValueFilter = (filters, referencedObjectTypeId) => {
  const otherFilters = [];
  let propertyNameFilter = undefined;
  let propertyValueFilter = undefined;
  for (const filter of filters) {
    if (isPropertyNameProperty(filter.property)) {
      invariant(propertyNameFilter === undefined, 'Property value changed event should have only one `hs_name` filter');
      propertyNameFilter = filter;
      continue;
    }
    if (isPropertyValueProperty(filter.property)) {
      invariant(propertyValueFilter === undefined, 'Property value changed event should have only one `hs_value` filter');
      propertyValueFilter = filter;
      continue;
    }
    if (isPropertyPreviousValueProperty(filter.property)) {
      throw new Error('Property value changed event should not have `hs_previous_value` filter');
    }
    otherFilters.push(filter);
  }
  if (propertyValueFilter && !propertyNameFilter) {
    throw new Error('`hs_name` filter is required when `hs_value` filter is provided');
  }
  if (!propertyNameFilter) {
    return otherFilters;
  }
  const propertyNameAndValueFilter = {
    filterType: PROPERTY_CHANGED_NAME_AND_VALUE,
    referencedObjectTypeId,
    propertyNameFilter,
    propertyValueFilter
  };
  return [propertyNameAndValueFilter, ...otherFilters];
};